/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/sap-hcm/SapHcmInboundConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapHcmInboundConfigCardTestIds = {
  btnEditSapHcmConfig: "btn-edit-sap-hcm-config",
  cardTitleSapHcmConfig: "card-title-sap-hcm-config",
  sapHcmConfigSection: "sap-hcm-config-section",
  textSapHcmEmployeeKeyField: "text-sap-hcm-employee-key-field"
} as const;
